import { getActiveChain } from '@app/constants/chains';

export function useChainExplorer() {
  const chain = getActiveChain();

  const explorer = chain?.explorers ? chain?.explorers[0] : null;

  return { explorer };
}
